import { safeStorage } from '@/app/utils/client';

const LIVE_CALL_CONSENT_STORAGE_KEY = 'live_video_call_consent_v1';

function getLiveCallConsentStorageKey(userId: string): string {
  return `${LIVE_CALL_CONSENT_STORAGE_KEY}_${userId}`;
}

export function hasLiveCallConsent(userId: string | undefined): boolean {
  if (!userId) {
    return false;
  }

  return safeStorage.getItem(getLiveCallConsentStorageKey(userId)) === 'true';
}

export function saveLiveCallConsent(userId: string): void {
  safeStorage.setItem(getLiveCallConsentStorageKey(userId), 'true');
}
